import * as go from 'gojs';
import { findAttachedAttentionNodes } from './attention-utils';

export const attentionOverrideResizingTool = (diagram: go.Diagram, category: string) => {
  const tool = diagram.toolManager.resizingTool;
  overrideResize(category, tool);
};

const overrideResize = (attentionCategory: string, tool: go.ResizingTool) => {
  const resizeBase = tool.resize.bind(tool);
  const doActivateBase = tool.doActivate.bind(tool);
  const doDeactivate = tool.doDeactivate.bind(tool);
  let attachedAttentionNodes: Record<string, go.Node> = {};

  tool.doActivate = () => {
    doActivateBase.call(tool);
    attachedAttentionNodes = findAttachedAttentionNodes(tool.diagram.nodes, attentionCategory);
  };

  tool.doDeactivate = () => {
    doDeactivate.call(tool);
    attachedAttentionNodes = {};
  };

  tool.resize = (newLocalBounds: go.Rect) => {
    if (!tool?.adornedObject?.part) {
      return;
    }

    const node = tool.adornedObject.part;

    resizeBase.call(tool, newLocalBounds);

    if (!!node?.key && node.key in attachedAttentionNodes) {
      moveAttentionNode(attachedAttentionNodes[node.key.toString()], node);
    }
  };
};

const moveAttentionNode = (attentionNode: go.Node, attachedNode: go.Part) => {
  const { x, y } = attachedNode.actualBounds;
  const { x: rx, y: ry, width } = attachedNode.resizeObject.actualBounds;
  const position = new go.Point(x + rx + width, y + ry);
  attentionNode.move(position, true);
};
